import { HEADER_TRANSLATION_KEY } from '../constants';

export default {
  es: {
    [HEADER_TRANSLATION_KEY]: {
      HEADER_ID_3_NAME: 'Recursos',
      HEADER_ID_3_ITEM_1_NAME: 'Blog',
      HEADER_ID_3_ITEM_1_DESCRIPTION:
        'Contenido relevante para tu aprendizaje.',
      HEADER_ID_3_ITEM_2_NAME: 'Descargables',
      HEADER_ID_3_ITEM_2_DESCRIPTION: 'Ebooks, herramientas, top-cases y más.',

      HEADER_CALL_BUTTON: 'Llámanos',
      HEADER_FREE_TRIAL_BUTTON: 'Agenda una demo',
      HEADER_FORM_PHONE_LABEL: 'Número de telefono',
      HEADER_FORM_PHONE_ERROR: 'Ingresar número válido',
      HEADER_FORM_PHONE_BUTTON: 'Contactar',

      HEADER_CONTACT_DIALOG_TITLE:
        'Contáctate con nuestro equipo \n de expertos',
      HEADER_CONTACT_DIALOG_DESCRIPTION:
        'Estamos disponibles de Lunes a Viernes de 9am a 6pm (PET)',

      HEADER_CONFIRMATION_DIALOG_TITLE:
        'Muchas gracias por \n registrar tus datos',
      HEADER_CONFIRMATION_DIALOG_DESCRIPTION:
        'En breve nos estaremos comunicando contigo \n para que vivas esta experiencia.',
      HEADER_CONFIRMATION_DIALOG_BUTTON: 'Finalizar',

      CLE_CTA: 'Conoce más',
      CLE_TITLE: 'Ecosistema de Desarrollo de Personas',
      CLE_DESCRIPTION:
        'Antes de elegir un programa de training para tu equipo, asegúrate de que podrás contar con las estadísticas necesarias para saber el impacto que generará.',
    },
  },
};
